// React Thirty Party Library
import React, { useState, useEffect } from "react";
import { Dropdown, message } from "antd";
import { useSelector, useDispatch } from "react-redux";

// Constants Library
import { TEMPLATE } from "../../../../../../constants";

// Components Library
import {
  TableList,
  ButtonLink,
  DrawerRemark,
} from "../../../../../../components";
import { ActionItems } from "./actions";
import {
  DrawerEditGroup,
  DrawerEditEmployee,
  DrawerViewBankInfo,
} from "../../components";

// Handler Library
import { tableHDLR, filter } from "../../../../../../handlers";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../../../../v1/services/util";

// Redux Actions

// Styles Library

const { EMPLOYEE_SUMMARY_COL } = TEMPLATE.TABLEDATA.EMPLOYEE;
const { EMPLOYEE_STATUS_TITLE } = TEMPLATE.EMPLOYEE;

const { reduxStoreWrapper } = REDUX_UTIL;

const TableEmployee = (props) => {
  const {
    source,
    filteredData,
    paginatedData,
    tabKey,
    setFilteredData,
    selectedRow,
    setSelectedRow,
    isLoad
  } = props;

  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tabStatus, setTabStatus] = useState({});
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenRemark, setIsOpenRemark] = useState(false);
  const [isOpenEditGroup, setIsOpenEditGroup] = useState(false);
  const [isOpenViewBankInfo, setIsOpenViewBankInfo] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState({});
  const [dataGroup, setDataGroup] = useState({});
  const [dataBankInfo, setDataBankInfo] = useState({});
  const [originalData, setOriginalData] = useState(false);
  const [isData, setIsData] = useState(false);
  const loading = useSelector(reduxStoreWrapper("style.loading.employee"));
  const user = useSelector(reduxStoreWrapper("user"));
  const company = useSelector(reduxStoreWrapper("company.byID")) || {};
  const group = useSelector(reduxStoreWrapper("group.byID"));

  useEffect(() => {
    if (originalData?.length === 0 && !isData && filteredData?.length) {
      setOriginalData(filteredData[tabKey]);
      setIsData(true);
    }
  }, [filteredData, isData, tabKey]);

  const filterData = (data) =>
    filter.filterHDLR.tableData(
      data,
      filteredInfo,
      sortedInfo,
    );

  useEffect(() => {
    const filteredAndSortedData = filterData(source);

    if (tabStatus[tabKey] && filteredAndSortedData.length !== 0) {
      setFilteredData(filteredAndSortedData);
    } 
  }, [tabKey, tabStatus[tabKey], sortedInfo, filteredInfo]);

  const handleTableChange = (_, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    setTabStatus((prev) => ({
      ...prev,
      [tabKey]: true,
    }));
  };

  const handleSearch = (_, confirm) => {
    confirm();
  };

  const columns = [
    ...EMPLOYEE_SUMMARY_COL({
      redux: {
        group,
        user,
        company,
      },
      func: {
        handleSearch,
        DrawerRemark: (data) => {
          setIsOpenRemark(true);
          setData(data);
        },
      },
    }),
    {
      title: "Actions",
      width: 100,
      fixed: "right",
      render: (_, record) => {
        return (
          <Dropdown
            menu={{
              items: ActionItems(
                record,
                setIsOpenEdit,
                setData,
                setIsOpenRemark,
                dispatch,
                messageApi,
                user
              ),
            }}
          >
            <ButtonLink>Actions</ButtonLink>
          </Dropdown>
        );
      },
    },
  ];

  const onSelectRow = (record, selected) => {
    tableHDLR.selectRow(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      record,
      selected
    );
  };

  const onSelectAllRows = (selected, selectedRows, changeRows) => {
    tableHDLR.selectAllRows(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      changeRows,
      selected
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onSelect: onSelectRow,
    onSelectAll: onSelectAllRows,
  };

  return (
    <>
      {contextHolder}
      <DrawerRemark
        isOpen={isOpenRemark}
        setIsOpen={setIsOpenRemark}
        refid={data.uid}
        statusData={EMPLOYEE_STATUS_TITLE}
        memid={data?.memid}
      />
      <DrawerEditEmployee
        isOpen={isOpenEdit}
        setIsOpen={setIsOpenEdit}
        data={data}
        company={company}
        user={user}
      />
      <DrawerEditGroup
        isOpen={isOpenEditGroup}
        setIsOpen={setIsOpenEditGroup}
        data={dataGroup}
      />
      <DrawerViewBankInfo
        isOpen={isOpenViewBankInfo}
        setIsOpen={setIsOpenViewBankInfo}
        data={dataBankInfo}
      />
      {/* {!isFiltered && paginatedData.length === 0 && user.uroleid === "A" ? (
        <Empty>
          <span style={{display: "flex", alignItems: "center", justifyContent: "center", color: "#A3A3A3"}}>
            Please 
            <ButtonLink style={{margin: "0px 5px"}} onClick={() => setIsModalOpen(true)}> apply filter </ButtonLink> 
            to view the employee list.
          </span>
        </Empty>
      ) : ( */}
      <TableList.DataList
        paginatedData={paginatedData}
        columnData={columns}
        loading={loading || (isLoad && paginatedData?.length === 0)}
        rowSelection={rowSelection}
        onChange={handleTableChange}
      />
      {/* )} */}
    </>
  );
};

export default TableEmployee;
